/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicMarkupAndDiscountMigration extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicMarkupAndDiscountMigration");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicMarkupAndDiscountMigration.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicMarkupAndDiscountMigration>): BackgroundJobPayloadForPeriodicMarkupAndDiscountMigration {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicMarkupAndDiscountMigration(), model);
        BackgroundJobPayloadForPeriodicMarkupAndDiscountMigration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicMarkupAndDiscountMigration>): BackgroundJobPayloadForPeriodicMarkupAndDiscountMigration {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicMarkupAndDiscountMigration.newInstance(<BackgroundJobPayloadForPeriodicMarkupAndDiscountMigration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicMarkupAndDiscountMigration) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicMarkupAndDiscountMigration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicMarkupAndDiscountMigration): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicMarkupAndDiscountMigration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
